import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Table, Popconfirm, Button, Tag, Descriptions } from 'antd';
import { Animated } from "react-animated-css";
import {
	uniq
} from 'ramda';

import 'moment-timezone';
import dayjs from 'dayjs';
import countries from '../../config/countriesInfo.json';


import UserModal from './modal/UserModal';
import OrganizationModal from './modal/OrganizationModal';

import './usermanagement.css';

import { UserAddOutlined, AppstoreAddOutlined, AppstoreOutlined, EditOutlined, DeleteOutlined, UserOutlined, ToolOutlined, TeamOutlined, UsergroupAddOutlined } from '@ant-design/icons';

import {
	userList,
	userDelete
} from '../../modules/user';


class UserManagement extends Component {
	constructor(props) {
		super(props);
		this.state = {
			addUserModal: false,
			addOrganizationModal: false,
			selectedUser: null,
			selectedOrg: 'new'
		}
	}

	componentDidMount() {
		const { userProfile, selectedOrganization } = this.props;
		if (userProfile.user.role.includes('admin') && this.props.userData.length === 0) {
			this.props.userList(selectedOrganization);
		}
	}

	componentDidUpdate(prevProps) {
		const { selectedOrganization, userProfile } = this.props;
		if (userProfile.user.role.includes('admin') && selectedOrganization !== prevProps.selectedOrganization) {
			this.props.userList(selectedOrganization);
		}
	}

	toggleAddUserModal = () => {
		const { addUserModal } = this.state;
		this.setState({ addUserModal: !addUserModal });
	}

	toggleAddOrganizationModal = () => {
		const { addOrganizationModal } = this.state;
		this.setState({ addOrganizationModal: !addOrganizationModal });
	}

	onSelectUser(user = null) {
		this.setState({ selectedUser: user.email }, () => {
			this.toggleAddUserModal();
		});
	}

	onSelecOrganization(id = 'new') {
		this.setState({ selectedOrg: id }, () => {
			this.toggleAddOrganizationModal();
		});
	}

	editUser = () => {
		const { userProfile } = this.props;
		this.setState({ selectedUser: userProfile.user.email }, () => {
			this.toggleAddUserModal();
		});
	}


	addUser = () => {
		this.setState({ selectedUser: null }, () => {
			this.toggleAddUserModal();
		});
	}


	addOrganization = () => {
		this.setState({ selectedOrg: 'new' }, () => {
			this.toggleAddOrganizationModal();
		});
	}

	onDeleteConfirm(email) {
		const { selectedUser } = this.state;
		const { selectedOrganization } = this.props;
		this.setState({ loading: true });
		this.props.userDelete(email).then(
			(res) => {
				if (email === selectedUser) {
					this.setState({ selectedUser: null });
				}
				this.props.userList(selectedOrganization);
			},
			(err) => {
				this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` });
			}
		);
	}

	onGoTo(loc) {
		this.props.history.push(loc);
	}



	render() {
		let { addUserModal, addOrganizationModal, selectedUser, selectedOrg } = this.state;
		const { organizations, selectedOrganization, userProfile } = this.props;

		let canDelete = (data) => {
			if (userProfile.user.role.includes('admin')) {
				return true;
			} else if (userProfile.user.role === 'superUser') {
				return true;
			} else if (userProfile.user.role === 'sales' && (!data.role.includes('admin') && data.role !== 'finance')) {
				return true;
			} else {
				return false;
			}
		}
		let canEdit = (data) => {
			if (userProfile.user.role.includes('admin')) {
				return true;
			} else if (userProfile.user.role === 'superUser') {
				return true;
			} else if (userProfile.user.role === 'sales' && (!data.role.includes('admin') && data.role !== 'finance')) {
				return true;
			} else {
				return false;
			}
		}

		const filterStatus = uniq(this.props.userData.map(user => (user.status) ? user.status : 'active')).map(s => ({ text: s, value: s }));
		const filterRole = uniq(this.props.userData.map(user => user.role)).map(s => ({ text: s, value: s }));

		const columns = [
			{
				title: 'Name',
				dataIndex: 'name',
				key: 'name',
				render: (text, data) => <span>{text}</span>,
				sorter: (a, b) => a.name.localeCompare(b.name)
			},
			{
				title: 'Email',
				dataIndex: 'email',
				key: 'email',
				sorter: (a, b) => a.email.localeCompare(b.email)
			}, {
				title: 'Role',
				dataIndex: 'role',
				key: 'role',
				filters: filterRole,
				onFilter: (value, record) => record.role.includes(value),
				sorter: (a, b) => a.role.localeCompare(b.role),
				render: (text, data) => <span>{(data.role.includes('admin') ? <ToolOutlined style={{ marginRight: '10px' }} /> : data.role === 'editor' ? <UsergroupAddOutlined style={{ marginRight: '10px' }} /> : <UserOutlined style={{ marginRight: '10px' }} />)}{(data.role.includes('admin') ? 'Admin' : data.role === 'user' ? 'User' : data.role)}</span>
			}, {
				title: 'Status',
				dataIndex: 'status',
				key: 'status',
				filters: filterStatus,
				onFilter: (value, record) => record.status.includes(value),
				sorter: (a, b) => a.status.localeCompare(b.status),
				render: text => (text === 'inactive') ? <Tag color="blue">Inactive</Tag> : <Tag>Active</Tag>
			}, {
				title: 'Action',
				key: 'action',
				render: (text, data) =>
					<span>
						{(canEdit(data) || (data.email === userProfile.user.email)) &&
							<Button
								type="link"
								icon={<EditOutlined />}
								onClick={() => {
									this.onSelectUser(data);
								}}
							/>
						}
						{(canDelete(data) && (data.email !== userProfile.user.email)) &&
							<Popconfirm
								title={`Delete User?`}
								onConfirm={() => {
									return this.onDeleteConfirm(data.email);
								}}
								okText="Yes"
								cancelText="No"
							>
								<Button icon={<DeleteOutlined />} type="link" />
							</Popconfirm>
						}
					</span>
			}];

		const orgColumns = [
			{
				title: 'ID',
				dataIndex: 'code',
				key: 'code',
				render: (text, data) => <span>{text}</span>,
				sorter: (a, b) => a.code.localeCompare(b.code)
			},
			{
				title: 'Name',
				dataIndex: 'name',
				key: 'name',
				render: (text, data) => <span>{text}</span>,
				sorter: (a, b) => a.name.localeCompare(b.name)
			},
			{
				title: 'Status',
				dataIndex: 'status',
				sorter: (a, b) => a.status.localeCompare(b.status),
				render: text => (text === 'inactive') ? <Tag color="blue">Inactive</Tag> : <Tag>Active</Tag>
			}, {
				title: 'Action',
				key: 'action',
				render: (text, data) =>
					<Button
						type="link"
						icon={<EditOutlined />}
						onClick={() => {
							this.onSelecOrganization(data.code);
						}}
					/>
			}];

		const data = this.props.userData;

		const sUser = this.props.userData.find(user => user.email === selectedUser);

		let organization = organizations.find(org => (org.code === selectedOrganization));
		let superadmin = (userProfile && userProfile.user && userProfile.user.access && userProfile.user.access.includes("crossOrganization") && userProfile.user && userProfile.user.role.includes("admin")) ? true : false;
		let admin = (userProfile && userProfile.user && userProfile.user.role.includes("admin")) ? true : false;
		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper">
					{/* <Card>
						<h3 className="title"><AppstoreOutlined /> Organization Information {(admin || superadmin) && <span className="extra"><Button type="link" onClick={() => { this.onSelecOrganization(organization.code) }}> <EditOutlined /> Edit </Button></span> }</h3>
						{organization &&
							<Descriptions column={2}>
								<Descriptions.Item label="ID">{organization.code}</Descriptions.Item>
								<Descriptions.Item label="Name">{organization.name}</Descriptions.Item>
								{ superadmin &&
								<>
								<Descriptions.Item label="API Key">{organization.apiKey}</Descriptions.Item>
								<Descriptions.Item label="API Key (Sandbox)">{organization.apiKeySandbox}</Descriptions.Item>
								</>
								}	
								{ (superadmin || admin) &&	
								<>				
								<Descriptions.Item label="GTM Endpoint">{organization.gtmEndpoint}</Descriptions.Item>								
								<Descriptions.Item label="GTM Endpoint (Sandbox)">{organization.gtmEndpointSandbox}</Descriptions.Item>
								</>	}
								<Descriptions.Item label="Contact Email">{organization.contact}</Descriptions.Item>		
								<Descriptions.Item label="Contact Person">{organization.contactPerson}</Descriptions.Item>		
								<Descriptions.Item label="Country">{countries.find(d=> d.code === organization.country )?countries.find(d=> d.code === organization.country ).name:''}</Descriptions.Item>		
								<Descriptions.Item label="Address">{organization.address}</Descriptions.Item>		
								<Descriptions.Item label="Service Duration Start">{organization.serviceStartDate?dayjs(organization.serviceStartDate).toString():''}</Descriptions.Item>		
								<Descriptions.Item label="Service Duration End">{organization.serviceEndDate?dayjs(organization.serviceEndDate).toString():''}</Descriptions.Item>	
								<Descriptions.Item label="Service Tier">{organization.serviceTier}</Descriptions.Item>			

							</Descriptions>
							
						}
					</Card>  */}
					{admin &&
						<Card>
							<h3 className="title"><TeamOutlined /> User Management <span className="extra"><Button type="link" icon={<UserAddOutlined />} onClick={() => { this.addUser() }}>Add User</Button></span></h3>
							<Table columns={columns} dataSource={data} rowKey='email' pagination={{ pageSize: 5 }} />
						</Card>
					}
					{superadmin && selectedOrganization === userProfile.user.organization &&
						<Card>
							<h3 className="title"><AppstoreAddOutlined /> Organization Management <span className="extra"><Button type="link" icon={<AppstoreAddOutlined />} onClick={() => { this.onSelecOrganization('new') }}>Add Organization</Button></span></h3>
							<Table columns={orgColumns} dataSource={organizations} rowKey='code' pagination={{ pageSize: 5 }} />
						</Card>
					}
					<UserModal
						show={addUserModal}
						toggleAddUserModal={this.toggleAddUserModal.bind(this)}
						data={(selectedUser) ? sUser : null}
						onClose={() => { this.props.userList(selectedOrganization) }}
					/>
					<OrganizationModal
						show={addOrganizationModal}
						toggleAddOrganizationModal={this.toggleAddOrganizationModal.bind(this)}
						data={selectedOrg}
					/>

				</div>
			</Animated>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	userData: state.user.userData,
	userProfile: state.user.userProfile,
	organizations: state.organization.organizations,
	selectedOrganization: state.user.selectedOrganization
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userList,
			userDelete
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
